import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import FilasDrug from './FilasDrug';

export default function DetailDrug({ values }) {
  const {
    chemSynonyms,
    chemVocabularies,
    chemVocabulariesCrossreferences,
    chemID,
    chemMoleculeType,
    chemPrefName,
  } = values;
  const chemVocabularyAttributes = ['Chembl ID', 'Name', 'Type'];

  return (
    <Tabs id="table-scroll">
      <TabList className="menuTabs">
        <Tab className="react-tabs__tab">General Info</Tab>
        <Tab className="react-tabs__tab">Vocabulary</Tab>
        <Tab className="react-tabs__tab">Synonyms</Tab>
      </TabList>

      {/* General Info */}
      <TabPanel className="tab-pane p-2">
        <table className="table">
          <tbody>
            <tr key={`${chemID}_${name}`}>
              <tr>
                <td className="text-right">
                  <strong>Chembl ID:</strong>
                </td>
                <td>
                  <a
                    href={`https://www.ebi.ac.uk/chembl/explore/compound/${chemID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {chemID} <i className="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td className="text-right">
                  <strong>Name:</strong>
                </td>
                <td>{chemPrefName}</td>
              </tr>
              <tr>
                <td className="text-right">
                  <strong>Type:</strong>
                </td>
                <td>{chemMoleculeType}</td>
              </tr>
            </tr>
          </tbody>
        </table>
      </TabPanel>

      {/* Vocabulary */}
      <TabPanel className="tab-pane p-2">
        <table className="table">
          <tbody>
            {chemVocabulariesCrossreferences?.map(ref => {
              const [left, right] = ref.split('_');
              const vocab = chemVocabularies.find(v => v.vocabulary === left);
              const resultado = vocab?.code;
              const lista = vocab?.code === chemID ? chemPrefName : vocab?.name;

              if (!left || !resultado || !lista) return null;

              return (
                <FilasDrug
                  key={ref}
                  left={left.toUpperCase()}
                  resultado={resultado}
                  lista={lista}
                ></FilasDrug>
              );
            })}
          </tbody>
        </table>
      </TabPanel>

      {/* Synonyms */}
      <TabPanel className="tab-pane p-2">
        <table className="table">
          <tbody>
            {chemSynonyms.map(synonym => (
              <tr key={synonym}>
                <td className="col-md-6">{synonym}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </TabPanel>
    </Tabs>
  );
}
